import React from 'react'
import { RichTextRenderer } from '../../../lib/components'
import { CMSOpportunityDetailsRegulationType } from '../../../lib/types'
import { CmsSectionText } from './cms-section-text-content'

const CMSRegulation = ({ regulation }: { regulation?: CMSOpportunityDetailsRegulationType }) => {
  if (!regulation?.regulationText?.length) {
    return null
  }

  return (
    <CmsSectionText dataTestId='cms-regulation-content'>
      <RichTextRenderer content={regulation.regulationText} variant='opportunity-details' />
    </CmsSectionText>
  )
}

export { CMSRegulation }
